import { generateUniqueId } from '@/assets/js/utils.js'
class WSDispatcher {
  constructor () {
    this.handlers = new Map()
  }

  register (module, handler, handlerId) {
    const key = handlerId || generateUniqueId()

    if (!this.handlers.has(module)) {
      this.handlers.set(module, {})
    }
    this.handlers.get(module)[key] = handler

    return () => {
      if (this.handlers.has(module)) {
        delete this.handlers.get(module)[key];
      }
    }
  }

  unregister (module, id) {
    if (this.handlers.has(module)) {
      delete this.handlers.get(module)[id]
    }
  }

  dispatch (message) {
    const { module, result } = typeof(message) === 'string' ? JSON.parse(message) : message
    if (this.handlers.has(module)) {
      Object.keys(this.handlers.get(module)).forEach(key => {
        this.handlers.get(module)[key]?.(result)
      })
    }
  }
}

export const wsDispatcher = new WSDispatcher()